import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { OutletCredentialsModel } from '../../shared/models/outlet.model';
import { OutletOtp } from '../../shared/models/otp.model';


@Injectable()
export class RegistrationService {
	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
	) {
	}

	updateOutletManagerProfile(credentials: OutletCredentialsModel): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agents/agent-manager`;
		return this.apiClientHelper.postForPromise(url, credentials);
	}

	initiateOutletLinking(credentials: OutletCredentialsModel): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agent-managers/agents/link/initiate`;
		return this.apiClientHelper.postForPromise(url, credentials);
	}

	linkOutlet(outletOtpCredentials: OutletOtp): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/agent-managers/agents/link`;
		return this.apiClientHelper.postForPromise(url, outletOtpCredentials);
	}

}
